import { render } from "./users.vue?vue&type=template&id=5b0fd552"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__